import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { actionResetData } from '../../actions';

const ResetData = ({ onClick }) => (
  <button onClick={onClick}>Reset Data</button>
);

ResetData.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onClick: () => dispatch(actionResetData()),
});

export default connect(undefined, mapDispatchToProps)(ResetData);



// WEBPACK FOOTER //
// ./app/components/resetData/index.js